import { Controller } from "react-hook-form";
import { TimePicker } from "react-accessible-time-picker";
import { useTranslation } from "react-i18next";

export default function TimeInput({ control, idx, name }: any) {
  const { t } = useTranslation();

  return (
    <Controller
      name={`openingHours.${idx}.${name}`}
      control={control}
      render={({ field }) => (
        <TimePicker
          {...field}
          onChange={field.onChange}
          value={field.value || { hour: "00", minute: "00" }}
          is24Hour={false}
          label=""
          minuteStep={1}
          popoverColumnHourTitle={t("hours")}
          popoverColumnMinuteTitle={t("minutes")}
          classes={{
            container: "w-40",
            timePicker:
              "flex items-center gap-2 border rounded-xl p-1 shadow-md bg-white transition-all duration-150 outline-none focus:outline-none",
            timeInputs: "flex gap-2",
            timeInput:
              "w-14 p-1 text-center border rounded-md bg-gray-50 outline-none focus:outline-none",
            separator: "mx-1 text-gray-400 font-medium",
              popoverContent:
              " bg-white border rounded-xl shadow-xl p-3 z-50 max-h-[80vh] overflow-auto",
            popoverColumns: "flex gap-2 ",
            popoverColumn:
              "flex flex-col gap-1 h-auto overflow-auto scrollbar-thin scrollbar-thumb-gray-300 scrollbar-track-gray-100",
            popoverColumnTitle:
              "text-gray-500 text-xs font-semibold mb-1 text-center",
            popoverItem:
              "p-1 rounded hover:bg-gray-100 cursor-pointer text-gray-700 text-sm text-center",
            popoverActiveItem:
              "bg-primary text-white font-semibold rounded text-sm text-center",
            timeTrigger:
              "flex-1 w-full flex items-center justify-center", 
          }}
        />
      )}
    />
  );
}
